// Copyright 2024 Merit International Inc. All Rights Reserved

export const reloadApp = () => {
  window.location.replace("/");
};
